import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-211a73c5")

_pushScopeId("data-v-211a73c5")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "custom-modal-overlay" }, null, -1)
const _hoisted_3 = { class: "custom-modal" }
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", null, "Update Subscription", -1)
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p class=\"subtitle\" data-v-211a73c5>Upgrade to Silver or Platinum! ✨</p><p class=\"benefits-title\" data-v-211a73c5>Unlock more with our premium plans:</p><ul class=\"benefits-list\" data-v-211a73c5><li data-v-211a73c5><span class=\"checkmark\" data-v-211a73c5>✓</span> Create more projects &amp; channels</li><li data-v-211a73c5><span class=\"checkmark\" data-v-211a73c5>✓</span> Add more team members</li><li data-v-211a73c5><span class=\"checkmark\" data-v-211a73c5>✓</span> Share extra data with My Drive</li><li data-v-211a73c5><span class=\"checkmark\" data-v-211a73c5>✓</span> Access calendar &amp; notifications</li><li data-v-211a73c5><span class=\"checkmark\" data-v-211a73c5>✓</span> And much more!</li></ul><p class=\"cta\" data-v-211a73c5>Upgrade now &amp; boost your productivity! 🚀</p>", 4)
const _hoisted_12 = { class: "modal-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.state.ui.isActive.customModal)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("button", {
                class: "close-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args)))
              }, "X")
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_12, [
                _createVNode("button", {
                  class: "upgrade-button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.upgrade && _ctx.upgrade(...args)))
                }, "Upgrade"),
                _createVNode("button", {
                  class: "close-button-text",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args)))
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})